// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Wrapper-module--fadeInAnimation--b87fe";
export var iconName = "Wrapper-module--iconName--0d1a3";
export var item = "Wrapper-module--item--3d619";
export var wide = "Wrapper-module--wide--7113b";